import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, InputGroup, Nav, Spinner } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, getOrdersListing, getTrackingOrdersListing, updateTrackingStatus } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import orderexchange from '../../assets/images/order-exchange.png';
import orderreturn from '../../assets/images/order-return.png';
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit.svg";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { checkUserPermissions } from '../../helpers/permission';
import Select from 'react-select'
import { useFormik } from 'formik'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { orderListFilter, orderListLimit, orderListPage, orderListSearch } from '../../atoms/orderListFilter';
import { useRecoilState } from 'recoil';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectionContext } from '../../Context/Store';
import { IoSearchOutline } from 'react-icons/io5';
import { FiRefreshCw } from 'react-icons/fi';
import toast from 'react-hot-toast';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { FaDownload } from "react-icons/fa6";
import * as XLSX from 'xlsx';
import Modal from 'react-bootstrap/Modal';

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '700',
            fontSize: '15px',
            color: '#0f172a',
            minHeight: '48px',
            padding: '8px 14px',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            minHeight: '48px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    headCells: {
        style: {
            display: 'flex',
            justifyContent: 'center',
            fontWeight: '600',
            fontSize: '9px',
            padding: '10px 14px',
            color: '#475569',
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
            backgroundColor: '#f8fafc',
        },
    },
    cells: {
        style: {
            display: 'flex',
            fontSize: '10px',
            fontWeight: '500',
            color: '#0f172a',
            padding: '10px 14px',
        },
    },
    rows: {
        style: {
            minHeight: '48px',
            borderBottom: '1px solid #eef2f7',
            paddingLeft: '8px',
            paddingRight: '8px',
            transition: 'background 0.15s ease',
            '&:not(:last-of-type)': { borderBottom: '1px solid #eef2f7' },
            '&:hover': { backgroundColor: '#f8fafc !important', cursor: 'pointer' },
        },
    },
    pagination: {
        style: {
            borderTop: '1px solid #eef2f7',
            minHeight: '52px',
            fontSize: '12px',
            color: '#475569',
        },
    },
};

const statusOptions = [
    { value: 'INITIATED', label: 'INITIATED' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'REJECTED', label: 'REJECTED' }
];

const deliveryStatusOptions = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'DISPATCHED', label: 'Dispatched' },
    { value: 'DELIVERED', label: 'Delivered' },
    { value: 'CANCELLED', label: 'Cancelled' }
];

const paymentStatusOptions = [
    { value: 'PENDING', label: 'PENDING' },
    { value: 'DONE', label: 'DONE' }
];

const Tracking = () => {
    const navigate = useNavigate()
    const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)
    const [filterData, setFilterdata] = useRecoilState(orderListFilter);
    const [orders, setOrders] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [filter, setFilter] = useState("completed");
    const [show, setShow] = useState(false);
    const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
    const [downloadOrdersExcel, setDownloadOrdersExcel] = useState(false);
    const [totalOrdesToDownload, setTotalOrdersToDownload] = useState([]);
    const [limitDownloadOrders, setLimitDownloadOrders] = useState(5);
    const [showTrackingModal, setShowTrackingModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [driverLocation, setDriverLocation] = useState(null);
    const [deliveryStatus, setDeliveryStatus] = useState('');
    const [isInitialRender, setIsInitialRender] = useState(true);
    const [activeTab, setActiveTab] = useState('CONFIRMED');

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const orderTypeOptions = [
        { value: null, label: 'NEW' },
        { value: 1, label: 'RETURN' },
        { value: 2, label: 'EXCHANGE' },
        { value: 3, label: 'DELIVERED' },
    ]

    const paymentModeOptions = [
        { value: "COD", label: 'COD' },
        { value: "ONLINE", label: 'ONLINE' },
    ]

    const logisticsStatusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'processing', label: 'Processing' },
        { value: 'success', label: 'Success' }
    ];

    const logisticsProviderOptions = [
        { value: 'volta', label: 'Volta' },
        { value: 'pidge', label: 'Pidge' }
    ];

    const [orderStatusOptions, setOrderStatusOptions] = useState([
        { value: 'CONFIRMED', label: 'CONFIRMED' },
        { value: 'DELIVERED', label: 'DELIVERED' }
    ]);

    const statusChipStyle = (bg, color = '#fff') => ({
        display: 'inline-block',
        backgroundColor: bg,
        color,
        padding: '3px 8px',
        borderRadius: '4px',
        fontWeight: 600,
        fontSize: '10px',
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
    });

    const columns = [
        {
            id: 'orderId',
            name: 'Order Id',
            selector: (row) => row?.orderId,
            cell: (row) => (
                <Tooltip title={row?.orderId} disableInteractive placement="top">
                    <div
                        style={{
                            backgroundColor: '#f1f5f9',
                            color: '#0f172a',
                            padding: '3px 10px',
                            borderRadius: '4px',
                            fontWeight: 600,
                            fontSize: '10px',
                            cursor: 'pointer',
                            textAlign: 'center',
                            maxWidth: '170px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/orderdetails/${row.id}`);
                        }}
                    >
                        {row?.orderId}
                    </div>
                </Tooltip>
            ),
            grow: 1.2,
            minWidth: '160px',
            center: true,
        },
        {
            name: 'Logistic',
            cell: (row) => {
                const provider = row?.logisticsJobs?.[0]?.logisticsProvider;
                const p = (provider || '').toLowerCase();
                if (!provider) return <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>;
                let bg = '#e0f2fe', color = '#0369a1';
                if (p === 'volta') { bg = '#dbeafe'; color = '#1d4ed8'; }
                else if (p === 'pidge') { bg = '#ede9fe'; color = '#6d28d9'; }
                return (
                    <span style={{
                        display: 'inline-block',
                        backgroundColor: bg,
                        color,
                        padding: '3px 10px',
                        borderRadius: '999px',
                        fontSize: '10px',
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        whiteSpace: 'nowrap',
                    }}>
                        {provider}
                    </span>
                );
            },
            center: true,
            grow: 0.8,
            minWidth: '95px',
        },
        {
            name: 'Logistic Status',
            cell: (row) => {
                const status = row?.logisticsJobs?.[0]?.status;
                if (!status) return <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>;
                const s = String(status).toLowerCase();
                let bg = '#f1f5f9', color = '#334155';
                if (s === 'success' || s === 'delivered') { bg = '#dcfce7'; color = '#166534'; }
                else if (s === 'processing' || s === 'in_transit' || s === 'dispatched') { bg = '#dbeafe'; color = '#1d4ed8'; }
                else if (s === 'pending') { bg = '#fef3c7'; color = '#92400e'; }
                else if (s === 'failed' || s === 'cancelled') { bg = '#fee2e2'; color = '#b91c1c'; }
                return (
                    <span style={{
                        ...statusChipStyle(bg, color),
                        textTransform: 'capitalize',
                    }}>
                        {status.replace(/_/g, ' ')}
                    </span>
                );
            },
            center: true,
            grow: 0.9,
            minWidth: '110px',
        },
        {
            id: 'createdAt',
            name: 'Date',
            selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
                    <div style={{ color: '#475569', fontSize: '10px', whiteSpace: 'nowrap' }}>
                        {moment(row?.createdAt).format('DD/MM/YY, hh:mm a')}
                    </div>
                </Tooltip>
            ),
            grow: 1.1,
            minWidth: '120px',
            center: true,
        },
        {
            id: 'orderType',
            name: 'Type',
            selector: (row) => row?.orderType,
            cell: (row) => {
                const t = row?.orderType;
                const label = t === 3 ? 'Delivered' : t === 2 ? 'Exchange' : t === 1 ? 'Return' : 'New';
                let bg = '#e0f2fe', color = '#0369a1';
                if (t === 1) { bg = '#fee2e2'; color = '#b91c1c'; }
                else if (t === 2) { bg = '#ede9fe'; color = '#6d28d9'; }
                else if (t === 3) { bg = '#dcfce7'; color = '#166534'; }
                return (
                    <span style={{
                        display: 'inline-block',
                        backgroundColor: bg,
                        color,
                        padding: '3px 10px',
                        borderRadius: '999px',
                        fontSize: '10px',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                    }}>
                        {label}
                    </span>
                );
            },
            center: true,
            grow: 0.7,
            minWidth: '85px',
        },
        {
            id: 'amount',
            name: 'Amount',
            selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
            cell: (row) => {
                const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
                return (
                    <Tooltip title={amt} disableInteractive placement="top">
                        <div style={{ fontWeight: 700, color: '#0f172a', fontSize: '11px' }}>
                            ₹{amt}
                        </div>
                    </Tooltip>
                );
            },
            center: true,
            grow: 0.6,
            minWidth: '80px',
        },
        {
            name: 'Return Id',
            cell: (row) => {
                let returnIds = [];
                if (row.returnIdForVedor) {
                    returnIds = typeof row.returnIdForVedor === 'string'
                        ? row.returnIdForVedor.split(',').map(id => id.trim())
                        : Array.isArray(row.returnIdForVedor) ? row.returnIdForVedor : [];
                }
                return (
                    <div className="d-flex justify-content-center flex-wrap gap-1">
                        {returnIds.length > 0 ? returnIds.map((id, index) => (
                            <Tooltip key={`return-${id}-${index}`} title={`View Return Order: ${id}`} disableInteractive placement="top">
                                <span
                                    style={{
                                        color: '#dc2626',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                        fontSize: '10px',
                                    }}
                                    onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                                >
                                    {id}
                                </span>
                            </Tooltip>
                        )) : <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>}
                    </div>
                );
            },
            center: true,
            grow: 0.8,
            minWidth: '95px',
            ignoreRowClick: true,
        },
        {
            name: 'Exchange Id',
            cell: (row) => {
                let exchangeIds = [];
                if (row.exchangeIdForVedor) {
                    exchangeIds = typeof row.exchangeIdForVedor === 'string'
                        ? row.exchangeIdForVedor.split(',').map(id => id.trim())
                        : Array.isArray(row.exchangeIdForVedor) ? row.exchangeIdForVedor : [];
                }
                return (
                    <div className="d-flex justify-content-center flex-wrap gap-1">
                        {exchangeIds.length > 0 ? exchangeIds.map((id, index) => (
                            <Tooltip key={`exchange-${id}-${index}`} title={`View Exchange Order: ${id}`} disableInteractive placement="top">
                                <span
                                    style={{
                                        color: '#0b6a93',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                        fontSize: '10px',
                                    }}
                                    onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                                >
                                    {id}
                                </span>
                            </Tooltip>
                        )) : <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>}
                    </div>
                );
            },
            center: true,
            grow: 0.8,
            minWidth: '95px',
            ignoreRowClick: true,
        },
        {
            name: 'Payment',
            cell: (row) => {
                const status = row?.paymentStatus;
                if (!status) return <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>;
                const done = status === 'DONE';
                return (
                    <span style={statusChipStyle(done ? '#dcfce7' : '#fef3c7', done ? '#166534' : '#92400e')}>
                        {done ? 'Completed' : 'Pending'}
                    </span>
                );
            },
            center: true,
            grow: 0.8,
            minWidth: '100px',
            sortable: true,
        },
    ];

    const conditionalRowStyles = [

        {
            when: row => row.returnIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
                '&:hover': {
                    backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
                }
            },
        },
        {
            when: row => row.exchangeIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
                '&:hover': {
                    backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
                }
            },
        },
        {
            when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
                '&:hover': {
                    backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
                }
            },
        },
    ];

    const handleOpenTrackingModal = (order) => {
        setSelectedOrder({
            ...order,

            paymentStatus: order.paymentStatus || 'PENDING',
            logisticsJobs: order.logisticsJobs || [{ status: 'pending' }],
            logisticsData: {
                ...(order.logisticsData || {}),
                currentStatus: order.logisticsData?.currentStatus || ''
            }
        });
        setShowTrackingModal(true);
    };

    const handleCloseTrackingModal = () => {
        setShowTrackingModal(false);
        setSelectedOrder(null);
        setDriverLocation(null);
    };


    const searchFormik = useFormik({
        initialValues: {
            startDate: filterData.startDate || '',
            endDate: filterData.endDate || '',
            orderType: filterData.orderType || '',
            selected_orderType: filterData.selected_orderType || '',
            paymentMode: filterData.paymentMode || '',
            selected_paymentMode: filterData.selected_paymentMode || '',
            paymentStatus: filterData.paymentStatus || '',
            selected_paymentStatus: filterData.selected_paymentStatus || ''
        },
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            setFilterdata(values);
            setShow(false);
        },
    });

    // Modify the fetchAllOrderData function to include status in the API call
    const fetchAllOrderData = async () => {
        setLoading(true);

        const params = {
            page,
            limit,
            searchQuery: search,
            status: activeTab, // Add the active tab status to the API call
            ...(filterData.startDate && { startDate: filterData.startDate }),
            ...(filterData.endDate && { endDate: filterData.endDate }),
            ...(filterData.orderType && { orderType: filterData.orderType }),
            ...(filterData.paymentMode && { paymentMode: filterData.paymentMode }),
            ...(filterData.paymentStatus && { paymentStatus: filterData.paymentStatus })
        };

        getTrackingOrdersListing(params)((response) => {
            if (response?.statusCode === 200) {
                setTotalOrdersToDownload(response?.data?.orders);
                setLimitDownloadOrders(response?.data?.totalItems);
                setOrders(response?.data?.orders);
                setTotalRows(response?.data?.totalItems || 0);
            } else {
                setTotalOrdersToDownload([]);
                setLimitDownloadOrders(5);
            }
            setLoading(false);
        });
    };

    // Add this effect to fetch data when tab changes
    useEffect(() => {
        if (!isInitialRender) {
            setPage(1); // Reset to first page when changing tabs
            fetchAllOrderData();
        }
    }, [activeTab]);


    const handleStatusChange = (field, value) => {
        setSelectedOrder(prev => {
            if (!prev) return prev;

            // Store original values when first opening modal
            const originalPaymentStatus = prev.originalPaymentStatus || prev.paymentStatus;
            const originalLogisticsStatus = prev.originalLogisticsStatus ||
                (prev.logisticsJobs?.[0]?.status || 'pending');

            // When changing ANY order to DELIVERED (works for both tabs)
            if (field === 'status' && value === 'DELIVERED') {
                return {
                    ...prev,
                    status: 'DELIVERED',
                    paymentStatus: 'DONE',
                    deliveryStatus: 'DELIVERED',
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: 'success'
                    }],
                    originalPaymentStatus,
                    originalLogisticsStatus
                };
            }

            // When changing back to CONFIRMED (from either tab)
            if (field === 'status' && value === 'CONFIRMED') {
                const shouldResetPaymentStatus = prev.paymentMode === 'COD' && prev.orderType == null;

                return {
                    ...prev,
                    status: 'CONFIRMED',
                    paymentStatus: shouldResetPaymentStatus ? 'PENDING' : originalPaymentStatus,
                    deliveryStatus: 'PENDING',
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: 'pending' // Always reset to pending when going back to CONFIRMED
                    }],
                    originalPaymentStatus: shouldResetPaymentStatus ? 'PENDING' : originalPaymentStatus,
                    originalLogisticsStatus: 'pending' // Also update the original logistics status
                };
            }

            // When changing logistics status in CONFIRMED tab
            if (field === 'logisticsStatus' && activeTab === 'CONFIRMED') {
                return {
                    ...prev,
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: value
                    }]
                };
            }

            // Only allow payment status changes if currently PENDING
            if (field === 'paymentStatus' && prev.paymentStatus === 'PENDING') {
                return {
                    ...prev,
                    paymentStatus: value,
                    originalPaymentStatus: value
                };
            }

            return prev;
        });
    };

    const handleSaveStatus = () => {
        if (!selectedOrder) return;

        setLoading(true);

        // Prepare payload
        const payload = {
            orderId: selectedOrder.id,
            orderType: selectedOrder.orderType,
            orderStatus: selectedOrder.status,
            logisticProvider: selectedOrder.logisticsJobs?.[0]?.logisticsProvider?.toLowerCase(),
            logisticsStatus: selectedOrder.logisticsJobs?.[0]?.status,
            paymentStatus: selectedOrder.paymentStatus,
            // Only include delivery status if it's being explicitly changed
            ...(selectedOrder.deliveryStatus !== selectedOrder.originalDeliveryStatus && {
                deliveryStatus: selectedOrder.deliveryStatus
            }),
            // Only include payment status if it's being explicitly changed
            ...(selectedOrder.paymentStatus !== selectedOrder.originalPaymentStatus && {
                paymentStatus: selectedOrder.paymentStatus
            })

        };

        updateTrackingStatus(payload)((response) => {
            setLoading(false);
            if (response?.success) {
                toast.success(response.message || 'Status updated successfully');
                setUpdate(!update); // Trigger refresh
                handleCloseTrackingModal();
            } else {
                toast.error(response?.error?.message || 'Failed to update status');
            }
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const deleteOrder = (id) => {
        deleteOrderItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
            }
        });
    };

    const handleFilterChange = (filter) => {
        setPage(1);
        setFilter(filter);
    };

    const onOrderTypeChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            orderType: selectedOption?.value,
            selected_orderType: selectedOption
        })
    }

    const onpaymentModeChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            paymentMode: selectedOption?.value,
            selected_paymentMode: selectedOption
        })
    }

    const onpaymentStatusChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            paymentStatus: selectedOption?.value,
            selected_paymentStatus: selectedOption
        })
    }

    const handleReset = () => {
        searchFormik.resetForm({
            values: {
                startDate: "",
                endDate: '',
                orderType: "",
                selected_orderType: "",
                paymentMode: "",
                selected_paymentMode: "",
                paymentStatus: "",
                selected_paymentStatus: ""
            }
        });
        setFilterdata({
            startDate: "",
            endDate: '',
            orderType: "",
            selected_orderType: "",
            paymentMode: "",
            selected_paymentMode: "",
            paymentStatus: "",
            selected_paymentStatus: ""
        });
        setSearch('');
        setShow(false);
        setUpdate(!update);
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (isFilterApplied) {
            searchFormik.handleSubmit(e);
        } else {
            handleReset();
        }
    };

    // Initial load effect
    useEffect(() => {
        setLoading(true);
        fetchAllOrderData(filter);
        setIsInitialRender(false);
    }, [filter, filterData]);

    // Search debounce effect (won't run on initial render)
    useEffect(() => {
        if (isInitialRender) return;

        const debounceTimer = setTimeout(() => {
            setLoading(true);
            fetchAllOrderData(filter);
        }, 500);

        return () => clearTimeout(debounceTimer);
    }, [search]);

    // Pagination effect (won't run on initial render)
    useEffect(() => {
        if (isInitialRender) return;

        setLoading(true);
        fetchAllOrderData(filter);
    }, [page, limit, update]);


    const getStatusColor = (status) => {
        switch (status) {
            case 'order_created':
                return '#33cd73ff';
            case 'admin_cancel':
                return '#dc3545'; // red (danger)
            case 'in_transit':
                return '#0d6efd'; // blue (primary)
            case 'delivered':
                return '#198754'; // green (success)
            case 'pending':
                return '#ffc107'; // yellow (warning)
            case 'failed':
                return '#6c757d'; // gray (secondary)
            default:
                return '#6f42c1'; // purple (default fallback)
        }
    };


    const isFilterApplied = !!(
        searchFormik.values.startDate ||
        searchFormik.values.endDate ||
        searchFormik.values.orderType ||
        searchFormik.values.paymentMode ||
        searchFormik.values.paymentStatus
    );

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;

    return (
        <div className="tracking-page">
            <style>{`
              /* Base layout — soft neutral bg + consistent 16px horizontal gutter */
              .tracking-page { background: #f9fafb; min-height: calc(100vh - 70px); }
              .main-content:has(.tracking-page) { background: #f9fafb; }
              .page-content:has(.tracking-page) { background: #f9fafb; }
              body:has(.tracking-page) .container-fluid,
              body:has(.tracking-page) .container {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              body:has(.tracking-page) .page-content,
              body:has(.tracking-page) #layout-wrapper.no-topbar .page-content,
              body:has(.tracking-page) #layout-wrapper .page-content {
                padding-top: 0 !important;
                padding-bottom: 24px !important;
                padding-left: 16px !important;
                padding-right: 16px !important;
              }
              .tracking-page h3 { font-size: 18px !important; }
              .tracking-page h4 { font-size: 16px !important; }
              .tracking-page h5 { font-size: 14px !important; }
              .tracking-page p  { font-size: 12px; }
              .tracking-page .small,
              .tracking-page small { font-size: 11px !important; }
              .tracking-page .btn { font-size: 12px; }
              .tracking-page .row { margin-bottom: 0; }
              .tracking-page .products-and-options .MuiPaper-root {
                border: 1px solid #e2e8f0 !important;
                border-radius: 10px !important;
                overflow: hidden;
              }

              /* Sticky header — bleeds edge-to-edge */
              .tracking-page .page-header-sticky {
                padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
                margin: 0 -16px 12px !important;
                top: 0 !important;
                background: #f9fafb !important;
                border-bottom: 1px solid #eef2f7 !important;
                box-shadow: none !important;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                flex-wrap: wrap;
              }

              /* Refresh button in header */
              .tracking-page .trk-refresh-btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                padding: 6px 14px;
                height: 34px;
                border-radius: 6px;
                border: 1px solid #e2e8f0;
                background: #fff;
                color: #475569;
                font-size: 12px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.15s ease;
              }
              .tracking-page .trk-refresh-btn:hover:not(:disabled) {
                border-color: #008695;
                color: #008695;
                background: rgba(0,134,149,0.06);
              }
              .tracking-page .trk-refresh-btn:disabled { opacity: 0.6; cursor: not-allowed; }
              .tracking-page .trk-refresh-btn svg { width: 14px; height: 14px; }
              @keyframes trkSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
              .tracking-page .trk-refresh-btn.is-spinning svg { animation: trkSpin 0.9s linear infinite; }
              @media (max-width: 480px) {
                .tracking-page .trk-refresh-btn {
                  width: 34px;
                  padding: 0 !important;
                }
                .tracking-page .trk-refresh-btn .trk-refresh-label { display: none; }
              }
              @media (max-width: 991px) {
                .tracking-page .page-header-sticky { padding: 16px 16px 12px !important; }
              }
              @media (max-width: 767.98px) {
                .tracking-page .page-header-sticky {
                  padding: 10px 16px 8px !important;
                  margin: 0 -16px 8px !important;
                  position: static !important;
                }
              }

              /* Toolbar row: search on the left + filter tabs on the right, outside header */
              .tracking-page .trk-toolbar {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                margin: 0 0 12px;
                flex-wrap: nowrap;
              }
              @media (max-width: 767.98px) {
                .tracking-page .trk-toolbar { margin: 0 0 8px; gap: 8px; }
              }

              /* Search input */
              .tracking-page .trk-search-input {
                border: 1px solid #e2e8f0 !important;
                border-radius: 4px !important;
                padding: 6px 12px !important;
                font-size: 12px !important;
                height: 34px !important;
                background: #fff !important;
                color: #0f172a !important;
                flex: 1;
                min-width: 0;
              }
              .tracking-page .trk-search-input:focus {
                border-color: #008695 !important;
                box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                outline: none;
              }

              /* Segmented tabs (replaces default bootstrap Nav tabs styling) */
              .tracking-page .trk-tabs {
                display: inline-flex;
                align-items: center;
                background: #fff;
                border: 1px solid #e2e8f0;
                border-radius: 8px;
                padding: 3px;
                gap: 2px;
              }
              .tracking-page .trk-tab-btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                padding: 6px 14px;
                font-size: 11.5px;
                font-weight: 600;
                color: #64748b;
                background: transparent;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                transition: all 0.15s ease;
                letter-spacing: '-0.01em';
              }
              .tracking-page .trk-tab-btn:hover:not(.is-active) { color: #0f172a; background: #f8fafc; }
              .tracking-page .trk-tab-btn.is-active {
                background: #008695;
                color: #fff;
                box-shadow: 0 2px 6px rgba(0,134,149,0.25);
              }
              @media (max-width: 480px) {
                .tracking-page .trk-tabs { flex-shrink: 0; padding: 2px; }
                .tracking-page .trk-tab-btn { padding: 5px 10px; font-size: 11px; }
              }

              /* Empty state */
              .tracking-page .trk-empty {
                width: 100%;
                min-height: 320px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 32px 20px;
                text-align: center;
                color: #64748b;
                background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
              }
              .tracking-page .trk-empty-icon { font-size: 40px; margin-bottom: 12px; opacity: 0.7; }
              .tracking-page .trk-empty-title {
                font-size: 14px; font-weight: 700; color: #0f172a;
                letter-spacing: -0.01em; margin: 0 0 4px;
              }
              .tracking-page .trk-empty-sub { font-size: 12px; color: #94a3b8; font-weight: 500; margin: 0; }

              /* Mobile card list (hidden on desktop) */
              .tracking-page .trk-mobile-list { display: none; }
              .tracking-page .trk-mobile-loading { min-height: 40vh; display: flex; align-items: center; justify-content: center; }
              .tracking-page .trk-mobile-pagination { display: none; }

              @media (max-width: 767.98px) {
                .tracking-page .trk-desktop-table { display: none !important; }
                .tracking-page .trk-mobile-list {
                  display: block;
                  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
                }

                /* Fixed bottom pagination */
                .tracking-page .trk-mobile-pagination {
                  display: flex !important;
                  position: fixed;
                  left: 0; right: 0; bottom: 0;
                  padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
                  background: #fff;
                  border-top: 1px solid #e2e8f0;
                  box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                  z-index: 1049;
                  align-items: center;
                  justify-content: space-between;
                  gap: 10px;
                }
                .tracking-page .tmp-btn {
                  width: 40px; height: 36px;
                  border-radius: 6px;
                  border: 1px solid #e2e8f0;
                  background: #fff;
                  color: #0f172a;
                  font-size: 16px;
                  font-weight: 700;
                  cursor: pointer;
                  display: inline-flex; align-items: center; justify-content: center;
                  transition: all 0.15s ease;
                }
                .tracking-page .tmp-btn:hover:not(:disabled) {
                  border-color: #008695;
                  color: #008695;
                  background: rgba(0,134,149,0.06);
                }
                .tracking-page .tmp-btn:disabled { opacity: 0.35; cursor: not-allowed; }
                .tracking-page .tmp-info {
                  font-size: 11px;
                  color: #475569;
                  display: inline-flex;
                  align-items: baseline;
                  gap: 4px;
                  flex: 1;
                  justify-content: center;
                  text-align: center;
                }
                .tracking-page .tmp-info strong { color: #008695; font-weight: 700; }
                .tracking-page .tmp-total { color: #94a3b8; font-size: 10px; }
              }

              /* Card */
              .tracking-page .trk-card {
                background: #fff;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                padding: 12px;
                margin-bottom: 8px;
                box-shadow: 0 1px 2px rgba(15,23,42,0.03);
                cursor: pointer;
                display: flex;
                flex-direction: column;
                gap: 10px;
                transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
              }
              .tracking-page .trk-card:active { transform: scale(0.995); }
              .tracking-page .trk-card:hover {
                border-color: #cbd5e1;
                box-shadow: 0 2px 6px rgba(15,23,42,0.06);
              }
              .tracking-page .trk-card-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
              }
              .tracking-page .trk-card-id {
                font-size: 12px;
                font-weight: 700;
                color: #0f172a;
                letter-spacing: -0.01em;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .tracking-page .trk-card-date {
                font-size: 10.5px;
                color: #94a3b8;
                font-weight: 500;
              }
              .tracking-page .trk-card-amount {
                font-size: 14px;
                font-weight: 800;
                color: #0f172a;
                letter-spacing: -0.02em;
              }
              .tracking-page .trk-card-meta {
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
              }
              .tracking-page .trk-card-meta-label {
                font-size: 9px;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.04em;
                font-weight: 700;
                margin-right: 4px;
                align-self: center;
              }
              .tracking-page .trk-card-ids {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                font-size: 10.5px;
                color: #475569;
              }
              .tracking-page .trk-card-ids a {
                text-decoration: underline;
                font-weight: 600;
                cursor: pointer;
              }
              .tracking-page .trk-card-divider {
                height: 1px;
                background: #eef2f7;
                margin: 2px 0;
              }

              /* Delete-confirm modal */
              .trk-delete-modal { max-width: 380px; }
              .trk-delete-modal-content {
                border: none !important;
                border-radius: 14px !important;
                box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18) !important;
                overflow: hidden !important;
              }
              @media (max-width: 480px) {
                .trk-delete-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
              }
            `}</style>

            <div className="page-header-sticky">
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.01em' }}>Order Tracking</h3>
                <button
                    type="button"
                    className={`trk-refresh-btn${loading ? ' is-spinning' : ''}`}
                    onClick={() => setUpdate(!update)}
                    disabled={loading}
                    aria-label="Refresh"
                    title="Refresh"
                >
                    <FiRefreshCw />
                    <span className="trk-refresh-label">Refresh</span>
                </button>
            </div>

            {/* Toolbar — search fills the left, filter tabs on the right */}
            <div className="trk-toolbar">
                <Form.Control
                    type="text"
                    className="trk-search-input"
                    placeholder="Search by Order Id..."
                    onChange={(e) => setSearch(e.target.value.trim())}
                />
                <div className="trk-tabs" role="tablist">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'CONFIRMED'}
                        className={`trk-tab-btn${activeTab === 'CONFIRMED' ? ' is-active' : ''}`}
                        onClick={() => setActiveTab('CONFIRMED')}
                    >
                        Confirmed
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'DELIVERED'}
                        className={`trk-tab-btn${activeTab === 'DELIVERED' ? ' is-active' : ''}`}
                        onClick={() => setActiveTab('DELIVERED')}
                    >
                        Delivered
                    </button>
                </div>
            </div>

            <div className='col-12 trk-desktop-table'>
                <Box className="products-and-options" sx={{ mt: 1 }}>
                    <Paper square className='shadow-none border-0'>
                        <div>
                            <DataTable
                                pointerOnHover
                                highlightOnHover
                                columns={columns}
                                conditionalRowStyles={conditionalRowStyles}
                                data={orders}
                                progressPending={loading}
                                progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                paginationPerPage={limit}
                                onRowClicked={(row) => handleOpenTrackingModal(row)}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                currentPage={page}
                                customStyles={queueDatatableCustomStyles}
                                noDataComponent={
                                    <div className="trk-empty">
                                        <div className="trk-empty-icon" aria-hidden="true">🚚</div>
                                        <div className="trk-empty-title">No orders to track</div>
                                        <div className="trk-empty-sub">Try switching tabs or adjust your search.</div>
                                    </div>
                                }
                            />
                        </div>
                    </Paper>
                </Box>
            </div>

            {/* Mobile card list */}
            <div className="trk-mobile-list">
                {loading ? (
                    <div className="trk-mobile-loading"><Loader /></div>
                ) : orders && orders.length > 0 ? (
                    orders.map((row) => {
                        const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
                        const t = row?.orderType;
                        const typeLabel = t === 3 ? 'Delivered' : t === 2 ? 'Exchange' : t === 1 ? 'Return' : 'New';
                        let tBg = '#e0f2fe', tColor = '#0369a1';
                        if (t === 1) { tBg = '#fee2e2'; tColor = '#b91c1c'; }
                        else if (t === 2) { tBg = '#ede9fe'; tColor = '#6d28d9'; }
                        else if (t === 3) { tBg = '#dcfce7'; tColor = '#166534'; }

                        const provider = row?.logisticsJobs?.[0]?.logisticsProvider;
                        const p = (provider || '').toLowerCase();
                        let pBg = '#e0f2fe', pColor = '#0369a1';
                        if (p === 'volta') { pBg = '#dbeafe'; pColor = '#1d4ed8'; }
                        else if (p === 'pidge') { pBg = '#ede9fe'; pColor = '#6d28d9'; }

                        const logisticStatus = row?.logisticsJobs?.[0]?.status;
                        const ls = String(logisticStatus || '').toLowerCase();
                        let lsBg = '#f1f5f9', lsColor = '#334155';
                        if (ls === 'success' || ls === 'delivered') { lsBg = '#dcfce7'; lsColor = '#166534'; }
                        else if (ls === 'processing' || ls === 'in_transit' || ls === 'dispatched') { lsBg = '#dbeafe'; lsColor = '#1d4ed8'; }
                        else if (ls === 'pending') { lsBg = '#fef3c7'; lsColor = '#92400e'; }
                        else if (ls === 'failed' || ls === 'cancelled') { lsBg = '#fee2e2'; lsColor = '#b91c1c'; }

                        const done = row?.paymentStatus === 'DONE';
                        const dStatus = row?.deliveryStatus;
                        const ds = String(dStatus || '').toLowerCase();
                        let dsBg = '#f1f5f9', dsColor = '#334155';
                        if (ds === 'delivered') { dsBg = '#dcfce7'; dsColor = '#166534'; }
                        else if (ds === 'dispatched') { dsBg = '#dbeafe'; dsColor = '#1d4ed8'; }
                        else if (ds === 'pending') { dsBg = '#fef3c7'; dsColor = '#92400e'; }
                        else if (ds === 'cancelled') { dsBg = '#fee2e2'; dsColor = '#b91c1c'; }

                        const returnIds = row?.returnIdForVedor
                            ? (typeof row.returnIdForVedor === 'string' ? row.returnIdForVedor.split(',').map(x => x.trim()) : (Array.isArray(row.returnIdForVedor) ? row.returnIdForVedor : []))
                            : [];
                        const exchangeIds = row?.exchangeIdForVedor
                            ? (typeof row.exchangeIdForVedor === 'string' ? row.exchangeIdForVedor.split(',').map(x => x.trim()) : (Array.isArray(row.exchangeIdForVedor) ? row.exchangeIdForVedor : []))
                            : [];

                        return (
                            <div key={row.id} className="trk-card" onClick={() => handleOpenTrackingModal(row)}>
                                <div className="trk-card-row">
                                    <div style={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <div className="trk-card-id">#{row?.orderId}</div>
                                        <div className="trk-card-date">
                                            {moment(row?.createdAt).format('DD MMM YY, hh:mm a')}
                                        </div>
                                    </div>
                                    <div className="trk-card-amount">₹{amt}</div>
                                </div>

                                <div className="trk-card-meta">
                                    <span style={{
                                        display: 'inline-block',
                                        backgroundColor: tBg,
                                        color: tColor,
                                        padding: '3px 10px',
                                        borderRadius: 999,
                                        fontSize: 10,
                                        fontWeight: 600,
                                    }}>{typeLabel}</span>
                                    {provider && (
                                        <span style={{
                                            display: 'inline-block',
                                            backgroundColor: pBg,
                                            color: pColor,
                                            padding: '3px 10px',
                                            borderRadius: 999,
                                            fontSize: 10,
                                            fontWeight: 600,
                                            textTransform: 'capitalize',
                                        }}>{provider}</span>
                                    )}
                                    {logisticStatus && (
                                        <span style={{
                                            display: 'inline-block',
                                            backgroundColor: lsBg,
                                            color: lsColor,
                                            padding: '3px 8px',
                                            borderRadius: 4,
                                            fontSize: 10,
                                            fontWeight: 600,
                                            textTransform: 'capitalize',
                                        }}>{String(logisticStatus).replace(/_/g, ' ')}</span>
                                    )}
                                </div>

                                {(returnIds.length > 0 || exchangeIds.length > 0) && (
                                    <div className="trk-card-ids">
                                        {returnIds.length > 0 && (
                                            <span>
                                                <span className="trk-card-meta-label">Return</span>
                                                {returnIds.map((id, i) => (
                                                    <a
                                                        key={`r-${id}-${i}`}
                                                        style={{ color: '#dc2626', marginRight: 6 }}
                                                        onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                                                    >{id}</a>
                                                ))}
                                            </span>
                                        )}
                                        {exchangeIds.length > 0 && (
                                            <span>
                                                <span className="trk-card-meta-label">Exchange</span>
                                                {exchangeIds.map((id, i) => (
                                                    <a
                                                        key={`e-${id}-${i}`}
                                                        style={{ color: '#0b6a93', marginRight: 6 }}
                                                        onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                                                    >{id}</a>
                                                ))}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="trk-card-divider" />
                                <div className="trk-card-meta" style={{ gap: 10 }}>
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        <span className="trk-card-meta-label" style={{ margin: 0 }}>Payment</span>
                                        <span style={{
                                            display: 'inline-block',
                                            backgroundColor: done ? '#dcfce7' : '#fef3c7',
                                            color: done ? '#166534' : '#92400e',
                                            padding: '3px 8px',
                                            borderRadius: 4,
                                            fontSize: 10,
                                            fontWeight: 600,
                                        }}>{done ? 'Completed' : 'Pending'}</span>
                                    </span>
                                    {dStatus && (
                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                            <span className="trk-card-meta-label" style={{ margin: 0 }}>Delivery</span>
                                            <span style={{
                                                display: 'inline-block',
                                                backgroundColor: dsBg,
                                                color: dsColor,
                                                padding: '3px 8px',
                                                borderRadius: 4,
                                                fontSize: 10,
                                                fontWeight: 600,
                                                textTransform: 'capitalize',
                                            }}>{String(dStatus).toLowerCase()}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="trk-empty">
                        <div className="trk-empty-icon" aria-hidden="true">🚚</div>
                        <div className="trk-empty-title">No orders to track</div>
                        <div className="trk-empty-sub">Try switching tabs or adjust your search.</div>
                    </div>
                )}
            </div>

            {/* Mobile-only fixed pagination */}
            {(() => {
                const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
                const canPrev = page > 1;
                const canNext = page < totalPages;
                return (
                    <div className="trk-mobile-pagination">
                        <button
                            type="button"
                            className="tmp-btn"
                            onClick={() => canPrev && handlePageChange(page - 1)}
                            disabled={!canPrev}
                            aria-label="Previous page"
                        >
                            ←
                        </button>
                        <span className="tmp-info">
                            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                            <span className="tmp-total">· {totalRows || 0} orders</span>
                        </span>
                        <button
                            type="button"
                            className="tmp-btn"
                            onClick={() => canNext && handlePageChange(page + 1)}
                            disabled={!canNext}
                            aria-label="Next page"
                        >
                            →
                        </button>
                    </div>
                );
            })()}

            {/* Tracking Modal */}
            <Modal
                show={showTrackingModal}
                onHide={handleCloseTrackingModal}
                scrollable
                centered
                size='md'
                dialogClassName="trk-modal"
                contentClassName="trk-modal-content"
            >
                <style>{`
                  .trk-modal-content {
                    border: none !important;
                    border-radius: 14px !important;
                    box-shadow: 0 20px 50px rgba(15,23,42,0.18) !important;
                    overflow: hidden !important;
                  }
                  .trk-modal-body-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #475569;
                    letter-spacing: 0.02em;
                    text-transform: uppercase;
                    margin: 0 0 4px;
                    display: block;
                  }
                  @media (max-width: 575.98px) {
                    .trk-modal { max-width: none !important; width: calc(100vw - 16px) !important; margin: 0 auto !important; }
                  }
                `}</style>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #eef2f7', padding: '14px 18px' }}>
                    <Modal.Title style={{ width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em' }}>
                                #{selectedOrder?.orderId}
                            </span>
                            {selectedOrder?.logisticsJobs?.[0]?.logisticsProvider && (() => {
                                const p = selectedOrder.logisticsJobs[0].logisticsProvider.toLowerCase();
                                let bg = '#e0f2fe', color = '#0369a1';
                                if (p === 'volta') { bg = '#dbeafe'; color = '#1d4ed8'; }
                                else if (p === 'pidge') { bg = '#ede9fe'; color = '#6d28d9'; }
                                return (
                                    <span style={{
                                        display: 'inline-block',
                                        backgroundColor: bg,
                                        color,
                                        padding: '3px 10px',
                                        borderRadius: 999,
                                        fontSize: 10,
                                        fontWeight: 600,
                                        textTransform: 'capitalize',
                                    }}>
                                        {selectedOrder.logisticsJobs[0].logisticsProvider}
                                    </span>
                                );
                            })()}
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: '16px 18px' }}>
                    {selectedOrder && (
                        <div>
                            <div style={{
                                background: '#fef3c7',
                                border: '1px solid #fde68a',
                                borderRadius: 8,
                                padding: '8px 10px',
                                fontSize: 11.5,
                                color: '#92400e',
                                marginBottom: 12,
                                lineHeight: 1.4,
                            }}>
                                {activeTab === 'DELIVERED'
                                    ? 'Changing order status from DELIVERED to CONFIRMED will create a new order in Pidge system.'
                                    : 'Changing logistic status from SUCCESS to PENDING will create new order in Pidge system.'}
                            </div>

                            <div style={{ background: '#f8fafc', border: '1px solid #eef2f7', borderRadius: 10, padding: 12 }}>
                                {/* Order Status — full width */}
                                <div className="row" style={{ marginBottom: 12 }}>
                                    <div className="col-12">
                                        <label className="trk-modal-body-label">Order Status</label>
                                        <Select
                                            options={orderStatusOptions}
                                            value={orderStatusOptions.find(opt => opt.value === selectedOrder.status)}
                                            onChange={(selected) => handleStatusChange('status', selected.value)}
                                            isSearchable
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>

                                {/* Logistics — 2 cols on all viewports */}
                                <div className="row gx-2" style={{ marginBottom: 12 }}>
                                    <div className="col-6">
                                        <label className="trk-modal-body-label">Provider</label>
                                        <Select
                                            options={logisticsProviderOptions}
                                            value={logisticsProviderOptions.find(opt =>
                                                opt.value === (selectedOrder.logisticsJobs?.[0]?.logisticsProvider?.toLowerCase() || 'pidge')
                                            )}
                                            isDisabled
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="trk-modal-body-label">Logistic Status</label>
                                        <Select
                                            options={logisticsStatusOptions}
                                            value={logisticsStatusOptions.find(opt =>
                                                opt.value === (selectedOrder.logisticsJobs?.[0]?.status || 'pending')
                                            )}
                                            onChange={(selected) => handleStatusChange('logisticsStatus', selected.value)}
                                            isDisabled={activeTab === 'DELIVERED' || (activeTab === 'CONFIRMED' && selectedOrder.status === 'DELIVERED')}
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>

                                {/* Payment + Delivery — 2 cols on all viewports */}
                                <div className="row gx-2">
                                    <div className="col-6">
                                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                            <span className="trk-modal-body-label" style={{ margin: 0 }}>Payment</span>
                                            <span style={{
                                                backgroundColor: selectedOrder.paymentMode === 'ONLINE' ? '#dcfce7' : '#fed7aa',
                                                color: selectedOrder.paymentMode === 'ONLINE' ? '#166534' : '#9a3412',
                                                padding: '2px 6px',
                                                borderRadius: 3,
                                                fontSize: 8.5,
                                                fontWeight: 700,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.03em',
                                                lineHeight: 1.2,
                                            }}>
                                                {selectedOrder.paymentMode}
                                            </span>
                                        </div>
                                        <Select
                                            options={paymentStatusOptions}
                                            value={paymentStatusOptions.find(opt => opt.value === selectedOrder.paymentStatus)}
                                            onChange={(selected) => handleStatusChange('paymentStatus', selected.value)}
                                            isSearchable
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isDisabled
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="trk-modal-body-label">Delivery</label>
                                        <Select
                                            options={deliveryStatusOptions}
                                            value={deliveryStatusOptions.find(opt => opt.value === selectedOrder.deliveryStatus)}
                                            isDisabled
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ padding: '12px 18px', borderTop: '1px solid #eef2f7', display: 'flex', gap: 8, justifyContent: 'stretch' }}>
                    <button
                        type="button"
                        onClick={handleCloseTrackingModal}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #e2e8f0',
                            background: '#fff',
                            color: '#0f172a',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.6 : 1,
                            transition: 'all 0.15s ease',
                        }}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={handleSaveStatus}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #008695',
                            background: '#008695',
                            color: '#fff',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.85 : 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            boxShadow: '0 3px 8px rgba(0,134,149,0.22)',
                            transition: 'all 0.15s ease',
                        }}
                    >
                        {loading ? (
                            <>
                                <Spinner size="sm" as="span" role="status" aria-hidden="true" />
                                Saving...
                            </>
                        ) : (
                            <>Save Changes</>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={modal}
                onHide={() => !loading && setModal(false)}
                centered
                backdrop={loading ? 'static' : true}
                keyboard={!loading}
                dialogClassName="trk-delete-modal"
                contentClassName="trk-delete-modal-content"
            >
                <Modal.Body style={{ padding: '22px 22px 18px', textAlign: 'center' }}>
                    <div
                        style={{
                            width: 52,
                            height: 52,
                            borderRadius: '50%',
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 12,
                            fontSize: 22,
                        }}
                    >
                        ✕
                    </div>
                    <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.01em' }}>
                        Delete order?
                    </h5>
                    <p style={{ fontSize: 12.5, color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                        This action cannot be undone. The selected order will be permanently removed.
                    </p>
                </Modal.Body>
                <Modal.Footer
                    style={{
                        padding: '12px 18px',
                        borderTop: '1px solid #eef2f7',
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'stretch',
                    }}
                >
                    <button
                        type="button"
                        onClick={() => setModal(false)}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #e2e8f0',
                            background: '#fff',
                            color: '#0f172a',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.6 : 1,
                            transition: 'all 0.15s ease',
                        }}
                    >
                        No
                    </button>
                    <button
                        type="button"
                        onClick={() => deleteOrder(deletingId)}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #dc2626',
                            background: '#dc2626',
                            color: '#fff',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.85 : 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            boxShadow: '0 3px 8px rgba(220,38,38,0.22)',
                            transition: 'all 0.15s ease',
                        }}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Deleting...
                            </>
                        ) : (
                            <>Yes, Delete</>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Tracking;